import { Pipe, PipeTransform } from '@angular/core';
import { toArray, isArray, objectContains } from '../utils/utils';

@Pipe({
  name: 'beforeWhere'
})
export class BeforeWherePipe implements PipeTransform {
  transform(collection: any, object: { [key: string]: any }): Array<any> {
    if (!isArray(collection)) {
      collection = toArray(collection);
    }
    if (!isArray(collection)) {
      return collection;
    }

    let index = collection.map((e: { [key: string]: any }) => objectContains(object, e)).indexOf(true);

    return collection.slice(0, index == -1 ? collection.length : index + 1);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./node_modules/ng-pipes/src/collection/before-where.pipe.ts